import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  measurements: [],
  currentMeasurement: null,
  isLoading: false,
  error: null,
};

const measurementSlice = createSlice({
  name: 'measurement',
  initialState,
  reducers: {
    setMeasurements: (state, action) => {
      state.measurements = action.payload;
    },
    setCurrentMeasurement: (state, action) => {
      state.currentMeasurement = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setMeasurements,
  setCurrentMeasurement,
  setLoading,
  setError,
  clearError,
} = measurementSlice.actions;

export default measurementSlice.reducer;
